import React, { Component } from 'react'
import { Card } from 'react-bootstrap';
import MainMenu from '../../components/menu/MainMenu';
import { INDIVIDUAL } from '../../resources/Utils';
import IndividualCustomer from './individual/IndividualCustomer'
import CorporateCustomer from './corporate/CorporateCustomer';
export default class UserDetail extends Component {

  render() {
    const {role} = this.props;
    const {type} = this.props.location.state;
    return (
      <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
        <Card.Body className="p-0 bg-grey">
          <MainMenu mainMenu={"account"} subMenu={"customer"} role={role}/>
          { type === INDIVIDUAL 
            ? <IndividualCustomer {...this.props} />
            : <CorporateCustomer {...this.props} />
          }
        </Card.Body>
      </Card>
    )
  }
}